/**
 * 注册或获取全局过滤器
 */
import Vue from 'vue';
import * as dict  from './dict';
import './extends/index';
//时间戳 转换成日期
//时间格式化 转换成日期
// {{1487815818000|dateFormat}}
// {{1487815818000|dateFormat('yyyy-MM-dd HH:mm')}}
// {{1487815818000|timeFormat}} 
// {{1487815818000|dateTimeFormat}} 

Vue.filter('parseInt', function (value) {
    return parseInt(value)
})
Vue.filter('dateFormat', function (value, fmt="yyyy-MM-dd") {
    return value ? new Date(value).format(fmt) : ""
})
Vue.filter('timeFormat', function (value) {
    return value ? new Date(value).format("HH:mm:ss") : ""
})
Vue.filter('dateTimeFormat', function (value) {
    return value ? new Date(value).format("yyyy-MM-dd HH:mm:ss") : ""
})

//显示默认图片
Vue.filter('defaultImg', function (url, setUrl='/static/img/nofound.png') {    
    return url || setUrl
});

//显示默认信息
Vue.filter('defaultText', function (text, setText='-') {    
    return text || setText
});

for (let item in dict) {
    Vue.filter(item, function(val) {
        let find = dict[item].find(x => x.value == val);
        return find ? find.label : val
    })
}

Vue.filter('nonePass', function (value) {
    return "***"
})



// WEBPACK FOOTER //
// ./src/util/filter.js